import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  alpha,
} from '@mui/material';

interface StatCardProps {
  title: string;
  value: number;
  icon: React.ReactElement;
  colorKey: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'error';
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  colorKey,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': onClick ? {
          transform: 'translateY(-2px)',
          boxShadow: 3,
        } : {},
      }}
    >
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ fontWeight: 600, lineHeight: 1.5 }}
            >
              {title}
            </Typography>
            <Typography variant="h5" component="div" sx={{ fontWeight: 700, my: 0.5 }}>
              {value.toLocaleString()}
            </Typography>
          </Box>
          <Box
            sx={{
              bgcolor: (theme) => alpha(theme.palette[colorKey].main, 0.1),
              color: `${colorKey}.main`,
              borderRadius: 1.5,
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {React.cloneElement(icon, { sx: { fontSize: 24 } })}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
